import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip'
import { STATUS, STATUS_BG_CLASS, STATUS_TEXT_CLASS } from './status'

const CONTAINER_CLASSES = 'tw:flex tw:items-center tw:gap-4 tw:p-4 tw:bg-white tw:flex-1 tw:min-w-0'

const ICON_BOX_CLASSES = 'tw:flex tw:items-center tw:justify-center '
  + 'tw:w-12 tw:h-12 tw:rounded-[8px] tw:text-2xl tw:shrink-0'

const TOOLTIP_ICON_CLASSES = 'fas fa-info-circle tw:text-gray-600'
const SUFFIX_CLASSES = 'tw:text-xl tw:font-medium tw:text-gray-500'

const renderTooltip = tooltip => {
  if (!tooltip)
    return null
  return (
    <Tooltip content={tooltip}>
      <i aria-label={tooltip} className={TOOLTIP_ICON_CLASSES} />
    </Tooltip>
  )
}

const renderSuffix = suffix =>
  suffix ? <span className={SUFFIX_CLASSES}>{suffix}</span> : null

const KpiCard = ({ icon, label, value, suffix, tooltip, status }) => (
  <div className={CONTAINER_CLASSES}>
    <div className={`${ICON_BOX_CLASSES} ${STATUS_BG_CLASS[status]} ${STATUS_TEXT_CLASS[status]}`}>
      {icon}
    </div>
    <div className="tw:flex tw:flex-col tw:min-w-0">
      <div className="tw:flex tw:items-center tw:gap-1 tw:text-sm tw:text-gray-500">
        <span>{label}</span>
        {renderTooltip(tooltip)}
      </div>
      <div className="tw:flex tw:items-baseline tw:gap-1">
        <span className="tw:text-xl tw:font-bold tw:text-gray-900">{value}</span>
        {renderSuffix(suffix)}
      </div>
    </div>
  </div>
)

KpiCard.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(STATUS)),
  suffix: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.node.isRequired
}

KpiCard.defaultProps = {
  status: STATUS.NEUTRAL,
  suffix: null,
  tooltip: null
}

export default KpiCard
